export default __webpack_public_path__ + "static/media/432.92a3ad36.png";